export enum CanvasErrorType {
  DYNAMIC_IMPORT_ERROR = 'DynamicImportError',
  RECOVERABLE_WEB_GL_ERROR = 'RecoverableWebGlError',
  UNRECOVERABLE_WEB_GL_ERROR = 'UnrecoverableWebGlError',
  ANONYMOUS_NOT_SUPPORTED_ERROR = 'AnonymousNotSupportedError',
  TENANT_ID_MISSING_ERROR = 'TenantIdMissingError',
  IDENTITY_USER_FAILED_ERROR = 'IdentityUserFailedError',
  CANVAS_RENDERER_ERROR = 'CanvasRendererError',
  SHADER_COMPILATION_ERROR = 'ShaderCompilationError',
  NO_SESSION_DATA_ERROR = 'NoSessionDataError',
  RUNTIME_ASSERTION_ERROR = 'RuntimeAssertionError',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export type ErrorType = {
  type: CanvasErrorType;
  isRecoverable: boolean;
};

export type IdentifiedError = {
  error: Error;
  type: CanvasErrorType;
  isRecoverable: boolean;
  sentryErrorId?: string;
  ignoreUfoReporting?: boolean;
};
